export default "__VITE_ASSET__BlE1N_rU__"